export enum PlanFastTradeTypeEnum {
  DEMO = 0,
  PRO = 1,
  START = 2,
  PREMIUM = 3,
  FREE = 4,
  RAIOX = 5,
  CRYPTO = 6,
  SIMULADOR = 7,
  DEMO_INATIVE = 98,
  DEMO_EXPIRED = 99,
}
